import type moment from 'moment-timezone';

export const rentalCarSelectableMinDate = (now: moment.Moment, actualDays: number) =>
  now.clone().startOf('day').add(actualDays, 'days').toDate();

export const rentalCarSelectableInitialDate = (now: moment.Moment, actualDays: number, hour: number) =>
  now.clone().startOf('day').add(actualDays, 'days').hour(hour).minute(0).second(0).millisecond(0).toDate();
